
export class OdxFile {
  id: number;
  data: string;
  fileName: string;
  size: number;
  certificate: number[];
  signature: number[];
}
